import { useState } from 'react';
import styled from 'styled-components';
// import faq from '../../data/faq.js';

// import BoxButton from '../BoxButton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 30px;

  & > h1 {
    font-weight: 400;
    font-size: 40px;
    line-height: 48px;
  }

  & > div.faq__item {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-self: stretch;
    gap: 16px;
    border-bottom: 1px solid #cdd0d2 !important;
    padding: 0 0 30px 0;
    cursor: pointer;

    & > p {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
    }

    & > div.faq__item__header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      & > h5 {
        margin: 0 !important;
        font-weight: 400 !important;
        font-size: 18px !important;
        line-height: 23px !important;
      }

      .gg-chevron-down {
        box-sizing: border-box;
        position: relative;
        display: block;
        transform: scale(var(--ggs, 1));
        width: 22px;
        height: 22px;
        border: 2px solid transparent !important;
        border-radius: 100px;
      }
      .gg-chevron-down::after {
        content: '';
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid !important;
        border-right: 2px solid !important;
        transform: rotate(45deg);
        left: 4px;
        top: 2px;
      }
    }
  }
`;

const FAQItem = ({ item }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq__item">
      <div
        className="faq__item__header"
        onClick={() => {
          setOpen(!open);
        }}
      >
        <h5>{item.q}</h5>
        <i className="gg-chevron-down"></i>
      </div>
      {open && <p dangerouslySetInnerHTML={{ __html: item.a }}></p>}
    </div>
  );
};

interface Props {
  title: string;
  questions: {
    q: string;
    a: string;
  }[];
}

const FAQ = ({ questions, title }: Props) => {
  const [showMore, setShowMore] = useState(false);
  const questionsFiltered = showMore ? questions : questions.slice(0, 5);
  return (
    <Container>
      <h1>{title}</h1>
      {questionsFiltered.map((question, index) => {
        return <FAQItem key={index} item={question} />;
      })}
      {/* {!showMore && (
        // <BoxButton
        //   title="Visa mer"
        //   wide={false}
        //   onClick={() => setShowMore(!showMore)}
        // />
      )} */}
    </Container>
  );
};

export default FAQ;
